<template>
  <div class="testQuestions">
    <div style="display:flex;">
      <!-- <div class="testQuestions-button" @click="choseQuestion">从题库选择</div>
      <div class="testQuestions-button" @click="deleteChapterMaterials">批量删除</div>-->
      <el-button type="primary" @click="choseQuestion" v-if="admin===1||limit===2">从题库选择</el-button>
      <el-button type="primary" @click="deleteChapterMaterials" v-if="admin===1||limit===2">批量删除</el-button>
    </div>
    <el-table
      ref="multipleTable"
      :data="testQuestionsList.records"
      style="width: 100%;margin-top: 21px;"
      row-key="id"
      border
      @selection-change="selectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" :index="indexMethod" label="排序" width="50"></el-table-column>
      <el-table-column
        prop="question.questionTypeName"
        label="类型"
        width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="question.title" show-overflow-tooltip label="题干">
        <template slot-scope="scope">
          <div
            v-if="scope.row.question!=undefined"
            class="message"
            @click="getInfoById(scope.row.questionId)"
          >
            <div class="htmltittle" v-html="scope.row.question.title"></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="question.answer"
        label="答案"
        align="center"
        width="60"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.big!=1">{{scope.row.question.answer||"-"}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column v-if="admin===1||limit===2" label="操作" width="60" align="center">
        <template slot-scope="scope">
          <i
            class="el-icon-delete testQuestions-icon"
            @click="deleteChapterMaterials(scope.row.id,2)"
          ></i>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next, jumper,  total, sizes"
      style="margin-top: 20px;text-align: left;"
      :total="testQuestionsList.total"
      :page-size="testQuestionsList.pageSize"
      :page-sizes="[10, 20, 30, 40]"
      :current-page="testQuestionsList.pageNumber"
      @size-change="testQuestionsSizeChange"
      @current-change="testQuestionsCurrentChange"
    ></el-pagination>
    <el-dialog
      title="从题库选择"
      :visible.sync="questionDialogVisible"
      :close-on-click-modal="false"
      width="60%"
    >
      <el-form ref="classRoomSearch" :model="classRoomSearch" label-width="0">
        <el-row :gutter="20">
          <el-col :sm="24" :md="6" :lg="6">
            <el-form-item prop="questionTypeId">
              <el-select
                style="width:100%"
                filterable
                clearable
                v-model="classRoomSearch.knowledgeId"
                placeholder="请输入考点"
              >
                <el-option
                  v-for="item in KnowledgeTree"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="6" :lg="6">
            <el-form-item prop="questionTypeId">
              <el-select
                style="width:100%"
                clearable
                v-model="classRoomSearch.questionTypeId"
                placeholder="请输入题型"
              >
                <el-option
                  v-for="item in classRoomTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="6" :lg="6">
            <el-form-item prop="title">
              <el-input
                clearable
                v-model="classRoomSearch.title"
                placeholder="请输入题干"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="3" :lg="3">
            <!-- <div class="classRoomButton" @click="classRoomPageList()">查询</div> -->
            <el-button type="primary" @click="classRoomPageList()">查询</el-button>
          </el-col>
          <el-col :sm="24" :md="3" :lg="3" style="float:right">
            <!-- <div class="classRoomButton" style="float:right;width:80px;" @click="batchAddChapterMaterials">添加</div> -->
            <el-button style="float:right" type="primary" @click="batchAddChapterMaterials()">添加</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="classRoomList.records"
        style="width: 100%;margin-top: 10px;"
        row-key="id"
        border
        @selection-change="QuestionSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" :index="indexMethod2" label="排序" width="50"></el-table-column>
        <el-table-column prop="questionTypeName" label="类型" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="title" show-overflow-tooltip label="题干">
          <template slot-scope="scope">
            <div class="message">
              <div class="htmltittle" v-html="scope.row.title"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="answer" label="答案" align="center" width="60" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.big!=1">{{scope.row.answer||"-"}}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next, jumper,  total, sizes"
        style="margin-top: 20px;text-align: left;"
        :total="classRoomList.total"
        :page-size="classRoomList.pageSize"
        :page-sizes="[10, 20, 30, 40]"
        :current-page="classRoomList.pageNumber"
        @size-change="classRoomSizeChange"
        @current-change="classRoomCurrentChange"
      ></el-pagination>
    </el-dialog>
    <el-dialog title="查看明细" :visible.sync="viewDetial" width="50%" left>
      <div class="view-content" v-if="viewForm.big==1">
        <div class="view-two">
          <div>
            <span style="width: 70px;white-space:nowrap">具体课程：</span>
            <span>{{viewForm.courseName}}</span>
          </div>
          <div>
            <span style="width: 70px;white-space:nowrap">试题类型：</span>
            <span>{{viewForm.big==1?"大题":(viewForm.big==-1&&viewForm.pid.length==1)?"小题":"试题"}}</span>
          </div>
        </div>
        <div class="view-two">
          <div>
            <span style="width: 70px;white-space:nowrap">是否上架：</span>
            <span>{{viewForm.state==1?"上架":"下架"}}</span>
          </div>
        </div>
        <div class="view-one">
          <span style="width: 70px;white-space:nowrap">试题题干：</span>
          <span v-html="viewForm.title"></span>
        </div>
      </div>

      <div class="view-content" v-else>
        <div class="view-two">
          <div>
            <span style="width: 70px;white-space:nowrap">具体课程：</span>
            <span>{{viewForm.courseName}}</span>
          </div>
          <div>
            <span style="width: 70px;white-space:nowrap">试题类型：</span>
            <span>{{viewForm.big==1?"大题":(viewForm.big==-1&&viewForm.pid.length==1)?"小题":"试题"}}</span>
          </div>
        </div>
        <div class="view-two">
          <div>
            <span style="width: 70px;white-space:nowrap">试题题型：</span>
            <span>{{viewForm.questionTypeName}}</span>
          </div>
          <div>
            <span style="width: 70px;white-space:nowrap">是否上架：</span>
            <span>{{viewForm.state==1?"上架":"下架"}}</span>
          </div>
        </div>
        <div class="view-two">
          <div>
            <span style="width: 70px;white-space:nowrap">难度系数：</span>
            <el-rate disabled v-model="viewForm.hard"></el-rate>
          </div>
        </div>
        <div class="view-one">
          <span style="width: 70px;white-space:nowrap">试题题干：</span>
          <span v-html="viewForm.title"></span>
        </div>
        <div class="view-one">
          <span style="width: 70px;white-space:nowrap">试题选项：</span>
          <div class="optint-list">
            <div v-for="(item,index) in viewForm.optionList" :key="index">
              <div
                style="font-size:14px;height:50px;line-height:50px;"
              >{{item.options}}:&nbsp;&nbsp;{{item.name}}</div>
            </div>
          </div>
        </div>
        <div class="view-one">
          <span style="width: 70px;white-space:nowrap">试题答案：</span>
          <span v-html="viewForm.answer"></span>
        </div>
        <div class="view-one">
          <span style="width: 70px;white-space:nowrap">试题解析：</span>
          <span v-html="viewForm.analysis"></span>
        </div>
        <div class="view-video">
          <span style="width: 70px;white-space:nowrap">视频/音频：</span>
          <span v-if="viewForm.videoPath">
            <video
              style="max-height: 400px;width: auto;margin-top:20px;"
              controls
              preload="auto"
              oncontextmenu="return false"
              :src="viewForm.videoPath"
              v-if="viewForm.videoPath?viewForm.videoPath.indexOf('mp4')>-1:false"
            ></video>
            <audio
              style="margin-top:20px;"
              :src="viewForm.videoPath"
              controls="controls"
              v-if="viewForm.videoPath?viewForm.videoPath.indexOf('mp3')>-1:false"
            ></audio>
          </span>
        </div>
      </div>

      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="viewDetial = false">取 消</el-button>
        <el-button type="primary" @click="viewDetial = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      admin: JSON.parse(localStorage.getItem("user")).admin,
      limit: JSON.parse(localStorage.getItem("jump")).limit,
      testQuestionsList: {},
      classRoomTypeList: [],
      chapterId: "",
      testQuestionsSearch: {
        pageNumber: 1,
        pageSize: 10,
        sortName: "id",
        sortOrder: "asc",
        id: JSON.parse(localStorage.getItem("jump")).id,
        type: JSON.parse(localStorage.getItem("jump")).type
      },
      classRoomSearch: {
        pageNumber: 1,
        pageSize: 10
      },
      classRoomList: {},
      questionDialogVisible: false,
      KnowledgeTree: [],
      classRoomTypeList: [],
      viewForm: [], //查看
      viewDetial: false,
      ids: [],
      questionIds: [],
      jump: {}
    };
  },
  computed: {},
  methods: {
    indexMethod(index) {
      return index + 1 + (this.testQuestionsSearch.pageNumber - 1) * 10;
    },
    indexMethod2(index) {
      return index + 1 + (this.classRoomSearch.pageNumber - 1) * 10;
    },
    questionPageList() {
      this.api.chapterMaterials
        .questionPageList(this.testQuestionsSearch)
        .then(result => {
          this.testQuestionsList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    testQuestionsSizeChange(pageSize) {
      this.testQuestionsSearch.pageSize = pageSize;
      this.questionPageList();
    },
    testQuestionsCurrentChange(pageNumber) {
      this.testQuestionsSearch.pageNumber = pageNumber;
      this.questionPageList();
    },
    selectionChange(val) {
      let arr = [];
      val.map(e => arr.push({ id: e.id }));
      this.ids = arr;
    },

    batchAddChapterMaterials() {
      let obj = {
        id: this.jump.id,
        chapterId: this.jump.chapterId,
        questionIds: this.questionIds,
        type: this.jump.type,
        chapterType: this.jump.chapterType
      };
      this.api.chapterMaterials
        .batchUpdateChapterMaterials(obj)
        .then(result => {
          if (result.success) {
            this.$message.success(result.message);
            this.questionPageList();
            this.questionDialogVisible = false;
          } else {
            this.$message.error(result.message);
          }
        });
    },
    deleteChapterMaterials(id, row) {
      let name = "将会删除该试题，是否确认删除";
      if (this.ids.length === 0 && row !== 2) {
        name = "请选择需要删除的题目";
      }
      this.$confirm(name, "系统消息", {
        type: "warning"
      })
        .then(() => {
          if (this.ids.length == 0) {
            let obj = { id: id };
            this.api.chapterMaterials
              .deleteChapterMaterials([obj])
              .then(result => {
                if (result.success) {
                  this.$message({
                    type: "success",
                    message: result.message
                  });
                  this.questionPageList();
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            this.api.chapterMaterials
              .deleteChapterMaterials(this.ids)
              .then(result => {
                if (result.success) {
                  this.$message({
                    type: "success",
                    message: result.message
                  });
                  this.ids = [];
                  this.questionPageList();
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          }
        })
        .catch(() => {});
    },
    // 获取试题信息
    getInfoById(id) {
      this.api.question.getInfoById({ id: id }).then(result => {
        if (result.success) {
          this.viewForm = result.data;
          this.viewDetial = true;
        } else {
          this.$message.error(result.message);
        }
      });
    },

    choseQuestion() {
      this.getKnowledgeSelectListByCourse();
      this.classRoomType();
      this.classRoomPageList();
      this.questionDialogVisible = true;
    },
    // 获取知识点列表
    getKnowledgeSelectListByCourse() {
      this.api.chapter
        .getKnowledgeSelectListByCourse({
          courseId: this.jump.courseId,
          keyword: ""
        })
        .then(result => {
          this.KnowledgeTree = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取试题类型
    classRoomType() {
      this.api.question
        .questionTypeList()
        .then(result => {
          this.classRoomTypeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    classRoomPageList() {
      this.api.question
        .pageList(this.classRoomSearch)
        .then(result => {
          this.classRoomList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    QuestionSelectionChange(val) {
      let arr = [];
      val.map(e => arr.push(e.id));
      this.questionIds = arr;
    },
    classRoomSizeChange(pageSize) {
      this.classRoomSearch.pageSize = pageSize;
      this.classRoomPageList();
    },
    classRoomCurrentChange(pageNumber) {
      this.classRoomSearch.pageNumber = pageNumber;
      this.classRoomPageList();
    }
  },
  watch: {},
  mounted() {
    this.jump = JSON.parse(localStorage.getItem("jump"));
    this.questionPageList();
  }
};
</script>
<style scoped>
.testQuestions {
  background-color: #fff;
  padding: 20px;
}
.testQuestions-button {
  width: 100px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  background-color: rgba(77, 148, 255, 1);
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  margin-right: 20px;
  margin-bottom: 20px;
}
.classRoomButton {
  height: 32px;
  width: 50px;
  background-color: rgba(77, 148, 255, 1);
  text-align: center;
  line-height: 32px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.testQuestions-icon {
  font-size: 16px;
}
</style>
<style lang="less" scoped>
.view-content {
  .view-video {
    width: 100%;
    display: flex;
    min-height: 50px;
    flex-direction: row;
    span {
      display: block;
      font-size: 14px;
      line-height: 50px;
    }
  }
  .view-one {
    width: 100%;
    display: flex;
    min-height: 50px;
    flex-direction: row;
    .optint-list {
      display: flex;
      flex-direction: column;
    }
    span {
      display: block;
      font-size: 14px;
      line-height: 50px;
    }
  }
  .view-two {
    height: 50px;
    display: flex;
    flex-direction: row;
    div {
      width: 50%;
      display: flex;
      flex-direction: row;
      align-items: center;
      span {
        display: block;
        font-size: 14px;
        line-height: 50px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/teachingResearch/testQuestions.vue